import type { GoogleTagPlatformConfig } from '@jane/bloom/loaders/rootLoader';

/**
 * Google Tag Platform encompasses two sets of tools:
 * - Google Tag Manager (GTM) https://support.google.com/tagmanager/answer/14847097?hl=en&ref_topic=15191151
 * - Google Analytics (GA, GA4, gtag) https://developers.google.com/tag-platform/gtagjs
 */

export const tagManagerScriptSrc = (gtmContainerId: string) =>
  `https://www.googletagmanager.com/gtm.js?id=${gtmContainerId}`;

const tagManagerInit = (gtmContainerId: string) =>
  `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmContainerId}');`;

export const HeadScripts = ({ gtmContainerId }: GoogleTagPlatformConfig) => {
  return (
    <>
      {gtmContainerId && (
        <script
          dangerouslySetInnerHTML={{
            __html: tagManagerInit(gtmContainerId),
          }}
        />
      )}
    </>
  );
};

export const BodyContent = ({ gtmContainerId }: GoogleTagPlatformConfig) => {
  if (!gtmContainerId) {
    return null;
  }

  return (
    <iframe
      src={`https://www.googletagmanager.com/ns.html?id=${gtmContainerId}`}
      height="0"
      width="0"
      style={{ display: 'none', visibility: 'hidden' }}
      title="GTM noscript"
    />
  );
};
